import React, { Fragment, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Button, Input, Progress, FormGroup, Label, Spinner } from 'reactstrap';
import { useMicrositePatients } from '../../../hooks/micrositioCompany/useMicrositePatients';
import './styleMicrositio.css';
import { ModalPreview } from './ModalPreview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Bar } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import { Dialog } from 'primereact/dialog';
import Select from 'react-select';
import { MultiSelect } from 'primereact/multiselect';
import { InputTextarea } from 'primereact/inputtextarea';
import { demo, pyrsa, sharp } from '../../../constant/globalConstantsTypeClients'
import { TabMenu } from 'primereact/tabmenu';
import { DialogPreviewResultsMicrosite } from './DialogPreviewResultsMicrosite';


const Sampl = (props) => {
    const {
        patients, iDateFrom, iDate_to, handleInputChangeFilters, handleFilters,

        actualPage, goToPage, totalRecords,
        modalPreview, togglePreview, handlePreview, typeModall, loadingPdf, previewWorkOrder, workMedicalOrderPDF,
        printWorkOrder,
        companyName, requirements,
        handleSearchMicrosite, loading, dataA, _id_agreement, codeAgreement, userType,

        changePatient, modalchange, toggleAgreement,
        // ? NEW
        listAgreement, handleChangeAgreement, valuId, dataInfo,
        selectedAgreement, setSelectedAgreement, setDataInfo, saveAdvancePayment, loadingChange,
        _url, listHistoric, modalAgreement, toggleHistoric, handleHistoric, searchQuery, handleCleanFilter,
        previewWorkOrderPDF,         modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview,
        dataTypeService, getTypeService, typeService, setTypeService,handleSelectValues, mSelectTypeService,
        totalCanceladas, totalCompleto, totalParcial, totalProceso, totalAbiertas,



         //? SECCION HISTORY PATIENT

        handleInputChangeHistory,
        handleSelectChangeHistory,
        start_date,
        end_date,
        id_patient,
      
        tableData,
        handleLoadTable,
        selectedStudy, studies, setSelectedStudy,


        isDownloading, isPatientSelected,
        setIsPatientSelected,
        handleDownloadClick,
        filteredRows, grouped,
        totalPerfiles, totalExamenes, totalAnalitos, totalCambios, rows,
        isLoadingTable,showStudyHint,
        handleClearAll,
        setSearchKey, totalNims, filteredPatientsOptions,
        handleSearchPatient, setSelectedPatientOption,
        loadingPatients, selectedPatientOption

    } = useMicrositePatients();
    


    const [expandedRows, setExpandedRows] = useState(null);


    const rowExpansionTemplate = (rowData) => {
        return (
            <div style={{
                padding: '16px 20px',
                background: '#f8f9fa',
                borderRadius: '8px',
                margin: '8px 0'
            }}>
                <h6 style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: '#495057',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <i className="fa fa-list-ul" style={{ color: '#1d5b83' }}></i>
                    Historial de cambios
                </h6>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {rowData?.historic.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                background: 'white',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                gap: '12px',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#1d5b83';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(29, 91, 131, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#e0e0e0';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                                <div style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontWeight: 600,
                                    fontSize: '12px'
                                }}>
                                    {index + 1}
                                </div>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                        <span style={{ fontWeight: 600, color: '#1d5b83', fontSize: '13px' }}>
                                            {item?.agreement_origen ?? "---"}
                                        </span>
                                        <i className="fa fa-arrow-right" style={{ color: '#6c757d', fontSize: '10px' }}></i>
                                        <span style={{ fontWeight: 600, color: '#149705ff', fontSize: '13px' }}>
                                            {item?.agreement_destination ?? "---"}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '11px', color: '#6c757d' }}>
                                        <span>
                                            <i className="fa fa-user mr-1"></i>
                                            {item?.username ?? "---"}
                                        </span>
                                        <span>|</span>
                                        <span>
                                            <i className="fa fa-calendar mr-1"></i>
                                            {item?.fech ?? "---"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // ? CONFIGURACIONES DE TABLA
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        const estatus = rowData?.id_estatus_order;
        const canDownload = [5, 6, 7, 8, 10, 13, 15, 18].includes(estatus);

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: '8px' }}>
                {canDownload && (<>
                    <Button
                        size="sm"
                        type="button"
                        className={rowData?.downloads > 0 ? "btn btn-pdf backgroundDownloads" : "btn btn-pdf backgroundZeroDownloads mr-3"}
                        onClick={() => printWorkOrder(rowData?.id_work_order)}
                        style={{
                            borderRadius: '8px',
                            padding: '6px 12px',
                            border: 'none',
                            transition: 'all 0.2s ease',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                        title={rowData?.downloads > 0 ? "Descargar PDF" : "Descargar PDF (sin descargas previas)"}
                    >
                        <i className="fa fa-file-pdf-o" />
                        {rowData?.downloads > 0 && (
                            <span style={{ fontSize: '10px', marginLeft: '4px' }}>
                                {rowData?.downloads}
                            </span>
                        )}
                    </Button>


                    <Button
                        size="sm"
                        type="button"
                        className={rowData?.downloads > 0 ? "btn btn-pdf backgroundPreview" : ""}
                        onClick={() => previewWorkOrderPDF(rowData?.id_work_order)}
                        style={{
                            borderRadius: '8px',
                            padding: '8px 12px',
                            border: 'none',
                            transition: 'all 0.2s ease',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                        title={rowData?.downloads > 0 ? "Previsualizar resultados" : "Previsualizar"}
                    >
                        <i className="fa fa-eye" />
                       
                    </Button>
                    </>
                )}
                {(_id_agreement === "0" && userType === "1" && _url === pyrsa) && (
                    <Button
                        size="sm"
                        type="button"
                        className="btn btn-pdf backgroundChangeAgreement"
                        onClick={() => changePatient(rowData?.id_work_order, rowData?.code_agreement, rowData?.name_patient, rowData?.nim, rowData?.id_agreement, rowData?.fechAndDate)}
                        title='Mover a nuevo convenio'
                        style={{
                            borderRadius: '8px',
                            padding: '6px 12px',
                            border: 'none',
                            transition: 'all 0.2s ease',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        <i className="fa fa-exchange" />
                    </Button>
                )}
            </div>
        );
    };

    // * STATUS LABELS AND SEVERITY
    const statusLabels = {
        1: "ABIERTA",
        2: "EN PROCESO",
        3: "EN PROCESO",
        4: "EN PROCESO",
        5: "PARCIAL",
        6: "COMPLETO",
        7: "COMPLETO",
        8: "COMPLETO",
        9: "COMPLETO",
        10: "COMPLETO",
        13: "COMPLETO",
        15: "COMPLETO",
        18: "COMPLETO",
        20: "CANCELADA",
        21: "COMPLETO"
    };

    const getSeverity = (status) => {
        switch (status) {
            case 'ABIERTA':
                return {
                    backgroundColor: '#00B8D9',
                    color: '#fff'
                };
            case 'EN PROCESO':
                return {
                    backgroundColor: '#FF8B00',
                    color: '#fff'
                };
            case 'PARCIAL':
                return {
                    backgroundColor: '#1f84d6ff',
                    color: '#fff'
                };
            case 'COMPLETO':
                return {
                    backgroundColor: '#149705ff',
                    color: '#fff'
                };
            case 'CANCELADA':
                return {
                    backgroundColor: '#F44336',
                    color: '#fff'
                };
            default:
                return {
                    backgroundColor: '#E0E0E0',
                    color: '#212529'
                };
        }
    };


    const dataa = {
        labels: ["Completados", "Pendientes"],
        datasets: [{
            data: [dataA.statusComplete, totalRecords - dataA.statusComplete],
            backgroundColor: [
                "rgba(20, 151, 5, 0.9)",
                "rgba(224, 224, 224, 0.6)"
            ],
            hoverBackgroundColor: [
                "rgba(20, 151, 5, 1)",
                "rgba(224, 224, 224, 0.8)"
            ],
            borderWidth: 0,
            spacing: 2,
        }],
    };

    const optionss = {
        maintainAspectRatio: false,
        cutout: "70%",
        plugins: {
            legend: { display: false },
            tooltip: {
                enabled: true,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 12,
                cornerRadius: 8,
                displayColors: true,
                callbacks: {
                    label: function (context) {
                        const label = context.label || '';
                        const value = context.parsed || 0;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            },
        },
        animation: {
            animateRotate: true,
            animateScale: true,
            duration: 1000,
            easing: 'easeOutQuart'
        },
    };

    const dataBar = {
        labels: ["Mujeres", "Hombres"],
        datasets: [{
            label: "Pacientes",
            data: [dataA.total_woman, dataA.total_man],
            backgroundColor: [
                "rgba(233, 30, 99, 0.8)",
                "rgba(29, 91, 131, 0.8)"
            ],
            hoverBackgroundColor: [
                "rgba(233, 30, 99, 1)",
                "rgba(29, 91, 131, 1)"
            ],
            borderRadius: 12,
            borderSkipped: false,
            maxBarThickness: 60,
        }],
    };

    const optionsBar = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 12,
                cornerRadius: 8,
                displayColors: true,
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${context.parsed.y}`;
                    }
                }
            }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: {
                    font: {
                        size: 12,
                        weight: 500
                    }
                }
            },
            y: {
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.05)',
                    drawBorder: false
                },
                ticks: {
                    stepSize: 5,
                    font: {
                        size: 11
                    }
                }
            },
        },
        animation: {
            duration: 1200,
            easing: 'easeOutQuart'
        },
    };

    // ? RENDER

    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        { label: 'Resultados', icon: 'pi pi-home' },
        { label: 'Histórico de pacientes', icon: 'pi pi-th-large' }
    ];

    const isDoctorSharp = userType === "2" && _url === sharp;
    const isDoctorDemo = userType === "2" && _url === demo;


       const workOrders = tableData?.data?.work_orders ?? [];

    const dynamicColumns = tableData?.data?.work_orders
        ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        ?.map(w => ({
            field: w.nim,
            header: (
            <div className="header-nim">
                <span className="nim">{w.nim}</span>
                <span className="fecha">{w.created_at_text}</span>
            </div>
            )
        })) || [];

    const options = [
        { value: "", label: "Seleccionar" },
        ...studies.map(study => ({
            value: study.value,
            label: study.label
        }))
    ];

    const isDownloadDisabled = !id_patient || isDownloading || !tableData;

    const dataStatus = {
        labels: ["Abiertas", "En proceso", "Parcial", "Completadas", "Canceladas"],
        datasets: [{
            data: [
                totalAbiertas,
                totalProceso,
                totalParcial,
                totalCompleto,
                totalCanceladas
            ],
            backgroundColor: [
                "#00B8D9",
                "#FF8B00",
                "#1f84d6",
                "#149705",
                "#F44336"
            ],
            borderWidth: 0
        }]
    };


    const optionsStatus = {
        maintainAspectRatio: false,
        cutout: "60%",
        interaction: {
            mode: "nearest",
            intersect: false
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: true,
                backgroundColor: 'rgba(0,0,0,0.8)',
                padding: 10,
                cornerRadius: 8,
                displayColors: true,
                callbacks: {
                    label: function (context) {
                        const label = context.label;
                        const value = context.parsed;
                        return `${label}: ${value}`;
                    }
                }
            }
        }
    };

    const renderItem = (label, value, color) => (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "6px",
                borderBottom: "1px solid #f1f1f1",
            }}
        >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                
                <span style={{
                    width: "3px",
                    height: "14px",
                    background: color,
                    borderRadius: "2px"
                }}></span>

                <span style={{
                    fontSize: "13px",
                    color: "#6c757d",
                    fontWeight: 500
                }}>
                    {label}
                </span>
            </div>

            <span style={{
                fontSize: "14px",
                fontWeight: 700,
                color: "#1d5b83"
            }}>
                {value}
            </span>
        </div>
    );

    const filteredDynamicColumns = React.useMemo(() => {
    
        if (!selectedStudy || selectedStudy === "ALL") {
            return dynamicColumns;
        }

        const isValidValue = (value) => {
            if (value === null || value === undefined) return false;

            const clean = String(value).trim();

            return (
                clean !== "" &&
                clean !== "-" &&
                clean !== "**" &&
                clean !== "null"
            );
        };

        return dynamicColumns.filter((col, index) => {

            if (index === 0) return true;

            const hasData = rows.some(row => isValidValue(row[col.field]));

            return hasData;
        });

    }, [dynamicColumns, rows, selectedStudy]);;

    return (
        <Fragment>
            <div
                className='container-global-zoom container-main'
            >
                {/* Background Pattern */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(29, 91, 131, 0.03) 1px, transparent 0)',
                    backgroundSize: '40px 40px',
                    pointerEvents: 'none',
                    zIndex: 0
                }}></div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                    {/* Header Card - Mejorado */}
                    <Card style={{
                        marginBottom: '25px',
                        background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                        border: 'none',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        borderRadius: '16px',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                    }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                        }}
                    >
                        <CardBody style={{ padding: '24px 30px' }}>
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        width: '64px',
                                        height: '64px',
                                        borderRadius: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '20px',
                                        background: 'rgba(255,255,255,0.15)',
                                        backdropFilter: 'blur(10px)'
                                    }}>
                                        {userType !== "2" && (
                                            <img
                                                alt="company"
                                                className="img-fluid"
                                                src={require("../../../assets/images/microsite/company.png")}
                                                style={{ width: "48px", height: "48px" }}
                                            />
                                        )}
                                        {userType !== "1" && (
                                            <img
                                                alt="doctor"
                                                className="img-fluid"
                                                src={require("../../../assets/images/microsite/male-doctor.svg")}
                                                style={{ width: "48px", height: "48px" }}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <Col sm="12">
                                            <Row>

                                                <Col sm="6">
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                        {userType !== "2" && (
                                                            <span
                                                                style={{
                                                                    fontSize: "14px",
                                                                    color: "#ffffff",
                                                                    fontWeight: "600",
                                                                    padding: "8px 16px",
                                                                    borderRadius: "20px",
                                                                    background: 'rgba(255,255,255,0.2)',
                                                                    backdropFilter: 'blur(10px)',
                                                                    whiteSpace: "nowrap",
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px'
                                                                }}
                                                            >
                                                                <i className="fa fa-info-circle mr-1"></i>
                                                                {companyName}
                                                                {codeAgreement && (
                                                                    <span style={{ fontStyle: "italic", opacity: 0.9 }}>
                                                                        "{codeAgreement}"
                                                                    </span>
                                                                )}
                                                            </span>
                                                        )}
                                                        {userType !== "1" && (
                                                            <span
                                                                style={{
                                                                    fontSize: "14px",
                                                                    color: "#ffffff",
                                                                    fontWeight: "600",
                                                                    padding: "8px 16px",
                                                                    borderRadius: "20px",
                                                                    background: 'rgba(255,255,255,0.2)',
                                                                    backdropFilter: 'blur(10px)',
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                            >
                                                                {companyName}
                                                            </span>
                                                        )}
                                                        {/* {requirements && (
                                                            <a
                                                                href={requirements.split("requirements")[1]}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    textDecoration: "none",
                                                                    fontSize: "14px",
                                                                    color: "#ffffff",
                                                                    fontWeight: "600",
                                                                    padding: "8px 16px",
                                                                    borderRadius: "20px",
                                                                    background: 'rgba(255,255,255,0.25)',
                                                                    backdropFilter: 'blur(10px)',
                                                                    transition: 'all 0.2s ease',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.background = 'rgba(255,255,255,0.35)';
                                                                    e.currentTarget.style.transform = 'scale(1.05)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
                                                                    e.currentTarget.style.transform = 'scale(1)';
                                                                }}
                                                            >
                                                                <i className="fa fa-external-link"></i>
                                                                {requirements}
                                                            </a>
                                                        )} */}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>


                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>




                    <Row className="g-4">
                        <Col lg={12} md={12} sm={12}>

                            <Card style={{
                                border: 'none',
                                borderRadius: '16px',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                overflow: 'hidden',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
                                }}
                            >

                                <CardBody style={{ padding: 0 }}>
                                    {(isDoctorSharp || isDoctorDemo) && (
                                        <div style={{ padding: '10px 20px', borderBottom: '1px solid #eee' }}>
                                            <TabMenu 
                                                model={items} 
                                                activeIndex={activeIndex} 
                                                onTabChange={(e) => setActiveIndex(e.index)}
                                                className="custom-tabmenu-blue-report"

                                            />
                                        </div>
                                    )} 
                                    {activeIndex === 0 && (
                                    <>
                                    <br />

                                    <Col sm="12">
                                        <Row>
                                            <Col lg={2} md={4} sm={12}>
                                                <Card style={{
                                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                                    border: 'none',
                                                    borderRadius: '16px',
                                                    height: '100%',
                                                    position: 'sticky',
                                                    top: '20px',
                                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                                    transition: 'all 0.3s ease'
                                                }}

                                                >
                                                    <CardHeader style={{
                                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                                        color: 'white',
                                                        padding: '20px 24px',
                                                        borderRadius: '16px 16px 0 0',
                                                        border: 'none',
                                                        position: 'relative',
                                                        overflow: 'hidden'
                                                    }}>
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '-50%',
                                                            right: '-50%',
                                                            width: '200%',
                                                            height: '200%',
                                                            background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                                                            pointerEvents: 'none'
                                                        }}></div>
                                                        <h6 className="mb-0" style={{
                                                            fontWeight: 700,
                                                            fontSize: '16px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                            position: 'relative',
                                                            zIndex: 1
                                                        }}>
                                                            <div style={{
                                                                width: '36px',
                                                                height: '36px',
                                                                borderRadius: '10px',
                                                                background: 'rgba(255,255,255,0.2)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backdropFilter: 'blur(10px)'
                                                            }}>
                                                                <i className="fa fa-filter" style={{ fontSize: '16px' }}></i>
                                                            </div>
                                                            Filtros de búsqueda
                                                        </h6>

                                                    </CardHeader>
                                                    <CardBody style={{ padding: '24px' }}>


                                                        <FormGroup className="mb-4">
                                                            <Label className='f-w-600 mb-2' style={{
                                                                fontSize: '13px',
                                                                color: '#495057',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span>Fecha de inicio</span>
                                                                </span>
                                                                {iDateFrom && (
                                                                    <span style={{
                                                                        fontSize: '10px',
                                                                        background: '#e3f2fd',
                                                                        color: '#007bff',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '10px',
                                                                        fontWeight: 600
                                                                    }}>
                                                                        ✓
                                                                    </span>
                                                                )}
                                                            </Label>
                                                            <div style={{ position: 'relative' }}>
                                                                <Input
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "44px",
                                                                        fontSize: "14px",
                                                                        transition: 'all 0.2s ease',
                                                                        paddingLeft: '44px',
                                                                        // background: iDateFrom ? '#f0f7ff' : '#fff',
                                                                        // fontWeight: iDateFrom ? 500 : 400
                                                                    }}
                                                                    type='date'
                                                                    name='iDateFrom'
                                                                    value={iDateFrom}
                                                                    onChange={handleInputChangeFilters}

                                                                />
                                                                <div style={{
                                                                    position: 'absolute',
                                                                    left: '12px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    color: iDateFrom ? '#007bff' : '#adb5bd',
                                                                    pointerEvents: 'none'
                                                                }}>
                                                                    <i className="fa fa-calendar" style={{ fontSize: '16px' }}></i>
                                                                </div>
                                                            </div>
                                                        </FormGroup>

                                                        <FormGroup className="mb-4">
                                                            <Label className='f-w-600 mb-2' style={{
                                                                fontSize: '13px',
                                                                color: '#495057',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                                                                    <span>Fecha de cierre</span>
                                                                </span>
                                                                {iDate_to && (
                                                                    <span style={{
                                                                        fontSize: '10px',
                                                                        background: '#d4edda',
                                                                        color: '#28a745',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '10px',
                                                                        fontWeight: 600
                                                                    }}>
                                                                        ✓
                                                                    </span>
                                                                )}
                                                            </Label>
                                                            <div style={{ position: 'relative' }}>
                                                                <Input
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "44px",
                                                                        fontSize: "14px",
                                                                        transition: 'all 0.2s ease',
                                                                        paddingLeft: '44px',

                                                                    }}
                                                                    type='date'
                                                                    name='iDate_to'
                                                                    value={iDate_to}
                                                                    onChange={handleInputChangeFilters}

                                                                />
                                                                <div style={{
                                                                    position: 'absolute',
                                                                    left: '12px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    color: iDate_to ? '#007bff' : '#adb5bd',
                                                                    pointerEvents: 'none'
                                                                }}>
                                                                    <i className="fa fa-calendar" style={{ fontSize: '16px' }}></i>
                                                                </div>
                                                            </div>
                                                        </FormGroup>

                                                        <FormGroup className={_id_agreement === "0" && userType === "1" ? "mb-4" : "d-none"}>
                                                            <Label className='f-w-600 mb-2' style={{
                                                                fontSize: '13px',
                                                                color: '#495057',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                                                                    <span>Convenio</span>
                                                                </span>
                                                                {valuId && (
                                                                    <span style={{
                                                                        fontSize: '10px',
                                                                        background: '#e9ecef',
                                                                        color: '#6c757d',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '10px',
                                                                        fontWeight: 600
                                                                    }}>
                                                                        ✓
                                                                    </span>
                                                                )}
                                                            </Label>
                                                            <Select
                                                                className="input-air-primary"
                                                                classNamePrefix="select"
                                                                name="client_id"
                                                                value={valuId}
                                                                options={listAgreement}
                                                                placeholder="Seleccione un convenio"
                                                                isClearable={true}
                                                                onChange={(e) => handleChangeAgreement(e)}
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    control: (provided, state) => ({
                                                                        ...provided,
                                                                        fontSize: '14px',
                                                                        minHeight: '44px',
                                                                        border: state.isFocused || valuId ? '2px solid #1d5b83' : '1px solid #e0e0e0',
                                                                        borderRadius: '12px',
                                                                        boxShadow: state.isFocused ? '0 0 0 3px rgba(29, 91, 131, 0.1)' : 'none',
                                                                        transition: 'all 0.2s ease',
                                                                        backgroundColor: valuId ? '#f8f9fa' : 'white',
                                                                        '&:hover': {
                                                                            borderColor: '#1d5b83'
                                                                        }
                                                                    }),
                                                                    option: (provided, state) => ({
                                                                        ...provided,
                                                                        fontSize: '13px',
                                                                        backgroundColor: state.isSelected ? '#1d5b83' : state.isFocused ? '#e3f2fd' : 'white',
                                                                        color: state.isSelected ? 'white' : '#333',
                                                                        padding: '12px 16px',
                                                                        cursor: 'pointer',
                                                                        borderRadius: state.isFocused ? '6px' : '0',
                                                                        transition: 'all 0.2s ease'
                                                                    }),
                                                                    singleValue: (provided) => ({
                                                                        ...provided,
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        fontWeight: 500
                                                                    }),
                                                                    placeholder: (provided) => ({
                                                                        ...provided,
                                                                        fontSize: '14px',
                                                                        color: '#adb5bd'
                                                                    }),
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        borderRadius: '12px',
                                                                        boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                                                                        border: '1px solid #e0e0e0',
                                                                        marginTop: '4px'
                                                                    }),
                                                                    menuList: (provided) => ({
                                                                        ...provided,
                                                                        padding: '4px'
                                                                    })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                        
                                                        {(isDoctorSharp || isDoctorDemo) && (
                                                            <FormGroup>
                                                                <label className='f-w-600' >Selecciona el tipo de servicio</label>
                                                    
                                                            <Select
                                                                    name="mSelectTypeService"
                                                                    value={mSelectTypeService || null}
                                                                    options={dataTypeService}
                                                                    isClearable
                                                                    placeholder="Selecciona una opción"
                                                                    onChange={(e) => handleSelectValues(e, "mSelectTypeService")}
                                                                />
                                                            </FormGroup>
                                                        )}
                                                              
                                                    
                                                        {/* Divider */}
                                                        <div style={{
                                                            height: '1px',
                                                            background: 'linear-gradient(90deg, transparent 0%, #e0e0e0 50%, transparent 100%)',
                                                            margin: '20px 0',
                                                            position: 'relative'
                                                        }}>

                                                            <label className='f-w-600' >Acciones</label>
                                                        </div>
                                                        <br />

                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                onClick={handleFilters}
                                                                color="primary"
                                                                block
                                                                className="mb-2"
                                                                disabled={loading}
                                                                style={{
                                                                    borderRadius: '12px',
                                                                    padding: '14px',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    border: 'none',
                                                                    boxShadow: (!iDateFrom && !iDate_to && !valuId) ? 'none' : '0 2px 8px rgba(29, 91, 131, 0.3)',
                                                                    transition: 'all 0.2s ease',
                                                                    position: 'relative',
                                                                    overflow: 'hidden',
                                                                    background: (!iDateFrom && !iDate_to && !valuId) ? '#e9ecef' : 'linear-gradient(135deg, #1d5b83 0%, #0d3b59 100%)',
                                                                }}

                                                            >
                                                                {loading ? (
                                                                    <>
                                                                        <i className='pi pi-spin pi-spinner mr-2'></i>
                                                                        Buscando...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <i className="fa fa-search mr-2"></i>
                                                                        Buscar
                                                                    </>
                                                                )}
                                                            </Button>

                                                            <Button
                                                                onClick={handleCleanFilter}
                                                                color="danger"
                                                                block
                                                                outline
                                                                className="mb-2"
                                                                disabled={loading}
                                                                style={{
                                                                    borderRadius: '12px',
                                                                    padding: '14px',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    borderWidth: '2px',
                                                                    transition: 'all 0.2s ease',
                                                                }}


                                                            >
                                                                <i className="fa fa-eraser mr-2"></i>
                                                                Limpiar filtros
                                                            </Button>

                                                            <Button
                                                                onClick={handleHistoric}
                                                                color="dark"
                                                                block
                                                                outline
                                                                className={_id_agreement === "0" && userType === "1" ? "" : "d-none"}
                                                                style={{
                                                                    borderRadius: '12px',
                                                                    padding: '14px',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    borderWidth: '2px',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                                    e.currentTarget.style.background = '#343a40';
                                                                    e.currentTarget.style.color = 'white';
                                                                    e.currentTarget.style.borderColor = '#343a40';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                                    e.currentTarget.style.background = 'transparent';
                                                                    e.currentTarget.style.color = '#343a40';
                                                                    e.currentTarget.style.borderColor = '#343a40';
                                                                }}
                                                            >
                                                                <i className="fa fa-history mr-2"></i>
                                                                Ver Histórico
                                                            </Button>
                                                        </div>
                                                        <br />
                                                            <div className='card-patient-microsite' >

                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginBottom: '10px',
                                                                    gap: '8px'
                                                                }}>
                                                                    <i className="fa fa-user-circle" style={{ color: '#1d5b83', fontSize: '16px' }}></i>
                                                                    <label className='f-w-600' style={{ margin: 0 }}>
                                                                        Buscar pacientes
                                                                    </label>
                                                                </div>

                                                                <Input
                                                                    type="search"
                                                                    placeholder="Escribe el nombre del paciente..."
                                                                    value={searchQuery}
                                                                    onChange={handleSearchMicrosite}
                                                                    className="form-control"
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        padding: "10px 12px",
                                                                        fontSize: "14px",
                                                                        border: '1px solid #d0d5dd',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                                        transition: 'all 0.2s ease'
                                                                    }}
                                                                    onFocus={(e) => {
                                                                        e.target.style.border = '1px solid #1d5b83';
                                                                        e.target.style.boxShadow = '0 0 0 2px rgba(29,91,131,0.15)';
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        e.target.style.border = '1px solid #d0d5dd';
                                                                        e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
                                                                    }}
                                                                />
                                                            </div>
                                                            

                                                    </CardBody>
                                                </Card>
                                            </Col>

                                            <Col lg="10" sm="12">

                                                <Col sm="12">
                                                    <Row className="g-3 mb-4">
                                                        {/* Card Ordenes Totales */}
                                                        <Col lg={6} md={6} sm={12}>
                                                            <Card
                                                                style={{
                                                                    border: 'none',
                                                                    borderRadius: '16px',
                                                                    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                                                    transition: 'all 0.3s ease',
                                                                    height: '100%',
                                                                }}
                                                            >
                                                                <CardBody className="pb-0" style={{ padding: '15px' }}>
                                                                    <div className="d-flex align-items-stretch gap-4">
                                                                       <div style={{
                                                                            flex: '1 1 20%',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            justifyContent: 'flex-start', 
                                                                            paddingTop: '5px'            
                                                                        }}>
                                                                            <h6
                                                                                className="mb-2"
                                                                                style={{
                                                                                    fontWeight: 600,
                                                                                    fontSize: '13px',
                                                                                    color: '#6c757d',
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.5px',
                                                                                }}
                                                                            >
                                                                                Ordenes Totales
                                                                            </h6>
                                                                            <br /> <br />

                                                                            <h3
                                                                                className="mb-2"
                                                                                style={{
                                                                                    fontWeight: 700,
                                                                                    fontSize: '36px',
                                                                                    margin: 0,
                                                                                    background:
                                                                                        'linear-gradient(135deg, #1d5b83 0%, #0d3b59 100%)',
                                                                                    WebkitBackgroundClip: 'text',
                                                                                    WebkitTextFillColor: 'transparent',
                                                                                    backgroundClip: 'text',
                                                                                }}
                                                                            >
                                                                                {totalRecords.toLocaleString()}
                                                                            </h3>

                                                                            <div
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '6px',
                                                                                    marginTop: '8px',
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-check-circle"
                                                                                    style={{ color: '#149705ff', fontSize: '14px' }}
                                                                                ></i>
                                                                                <span
                                                                                    style={{
                                                                                        color: '#149705ff',
                                                                                        fontWeight: 600,
                                                                                        fontSize: '14px',
                                                                                    }}
                                                                                >
                                                                                    {dataA.statusComplete} Completados
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {/* CENTRO: GRÁFICA */}
                                                                        <div
                                                                            style={{
                                                                                flex: '0 0 170px',  
                                                                                width: '170px',
                                                                                height: '170px',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                position: 'relative',
                                                                                top: '23px'
                                                                            }}
                                                                        >
                                                                            {dataa.datasets[0].data.some((value) => value > 0) ? (
                                                                                <>
                                                                                    <div style={{ width: '140px', height: '140px' }}>
                                                                                        <Doughnut data={dataa} options={optionss} />
                                                                                    </div>

                                                                                    <div
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '50%',
                                                                                            left: '50%',
                                                                                            transform: 'translate(-50%, -50%)',
                                                                                            textAlign: 'center',
                                                                                            pointerEvents: 'none',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                fontSize: '20px',
                                                                                                fontWeight: 700,
                                                                                                color: '#1d5b83',
                                                                                                lineHeight: 1,
                                                                                            }}
                                                                                        >
                                                                                            {totalRecords > 0
                                                                                                ? ((dataA.statusComplete / totalRecords) * 100).toFixed(0)
                                                                                                : 0}
                                                                                            %
                                                                                        </div>

                                                                                        <div
                                                                                            style={{
                                                                                                fontSize: '11px',
                                                                                                color: '#6c757d',
                                                                                                textTransform: 'uppercase',
                                                                                                letterSpacing: '0.5px',
                                                                                                marginTop: '2px',
                                                                                            }}
                                                                                        >
                                                                                            Completado
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <img
                                                                                    src={require('../../../assets/images/microsite/chart-doughnut.svg')}
                                                                                    alt="chart"
                                                                                    style={{
                                                                                        width: '120px',
                                                                                        height: '120px',
                                                                                        opacity: 0.5,
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>


                                                                        <div
                                                                            style={{
                                                                                width: '0px',
                                                                                minWidth: '2px',      
                                                                                height: '188px',
                                                                                background: '#c2c2c2', 
                                                                                margin: '0 15px',
                                                                                flexShrink: 0        
                                                                            }}
                                                                        />

                                                                        <div style={{ flex: '1 1 40%', textAlign: 'right' }}>
                                                                            {/* <h6
                                                                                className="mb-2"
                                                                                style={{
                                                                                    fontWeight: 600,
                                                                                    fontSize: '13px',
                                                                                    color: '#6c757d',
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.5px',
                                                                                }}
                                                                            >
                                                                                Órdenes Canceladas
                                                                            </h6>

                                                                            <div
                                                                                style={{
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '6px',
                                                                                    padding: '6px 12px',
                                                                                    borderRadius: '14px',
                                                                                    backgroundColor: 'rgba(232,63,63,0.1)',
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-ban"
                                                                                    style={{ color: '#e83f3f', fontSize: '12px' }}
                                                                                ></i>
                                                                                <span
                                                                                    style={{
                                                                                        color: '#e83f3f',
                                                                                        fontWeight: 700,
                                                                                        fontSize: '14px',
                                                                                    }}
                                                                                >
                                                                                    {dataA.statusCancell}
                                                                                </span>
                                                                            </div> */}
                                                                                <h6
                                                                                        className="mb-2 text-left"
                                                                                        style={{
                                                                                            fontWeight: 600,
                                                                                            fontSize: '13px',
                                                                                            color: '#6c757d',
                                                                                            textTransform: 'uppercase',
                                                                                            letterSpacing: '0.5px',
                                                                                        }}
                                                                                    >
                                                                                        ESTATUS DE ORDENES
                                                                                    </h6>
                                                                            <div
                                                                                style={{
                                                                                    flex: '1 1 40%',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'space-between',
                                                                                    gap: '20px'
                                                                                }}
                                                                            >
                                                                                {/* RESUMEN */}
                                                                                <div style={{ textAlign: 'left' }}>
                                                                                
                                                                                    <div className="d-flex flex-column gap-2 mt-2">

                                                                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "3px" }}>

                                                                                            {renderItem("Abiertas", totalAbiertas, "#00B8D9")}
                                                                                            {renderItem("En proceso", totalProceso, "#FF8B00")}
                                                                                            {renderItem("Parcial", totalParcial, "#1f84d6")}
                                                                                            {renderItem("Completo", totalCompleto, "#3ad813")}
                                                                                            {renderItem("Canceladas", totalCanceladas, "#F44336")}

                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                                {/* DONA DE ESTATUS */}
                                                                                <div style={{
                                                                                    width: "140px",
                                                                                    height: "140px",
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}>
                                                                                    <Doughnut data={dataStatus} options={optionsStatus} />
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>


                                                        <Col lg={6} md={6} sm={12}>
                                                            <Card style={{
                                                                border: 'none',
                                                                borderRadius: '16px',
                                                                boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                                                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                                                transition: 'all 0.3s ease',
                                                                height: '100%'
                                                            }}

                                                            >
                                                                <CardBody className='pb-0' style={{ padding: '24px' }}>
                                                                    <h6 className="mb-3" style={{
                                                                        fontWeight: 600,
                                                                        fontSize: '13px',
                                                                        color: '#6c757d',
                                                                        textTransform: 'uppercase',
                                                                        letterSpacing: '0.5px'
                                                                    }}>
                                                                        Total Pacientes: <span style={{ color: '#1d5b83', fontSize: '16px' }}>{dataA.total_woman + dataA.total_man}</span>
                                                                    </h6>
                                                                    <Row>
                                                                        <Col sm={8}>
                                                                            <div className="mb-3">
                                                                                <div className="d-flex justify-content-between mb-1">
                                                                                    <small style={{ fontWeight: 600, color: '#495057' }}>
                                                                                        <i className="fa fa-female mr-1" style={{ color: '#e91e63' }}></i>
                                                                                        Mujeres: {dataA.total_woman}
                                                                                    </small>
                                                                                    <small style={{ fontWeight: 600, color: '#495057' }}>
                                                                                        {((dataA.total_woman / (dataA.total_woman + dataA.total_man)) * 100).toFixed(1)}%
                                                                                    </small>
                                                                                </div>
                                                                                <Progress
                                                                                    value={(dataA.total_woman / (dataA.total_woman + dataA.total_man)) * 100}
                                                                                    className="progress-pink"
                                                                                    style={{
                                                                                        height: '12px',
                                                                                        borderRadius: '10px',
                                                                                        backgroundColor: '#fce4ec'
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <div className="d-flex justify-content-between mb-1">
                                                                                    <small style={{ fontWeight: 600, color: '#495057' }}>
                                                                                        <i className="fa fa-male mr-1" style={{ color: '#1d5b83' }}></i>
                                                                                        Hombres: {dataA.total_man}
                                                                                    </small>
                                                                                    <small style={{ fontWeight: 600, color: '#495057' }}>
                                                                                        {((dataA.total_man / (dataA.total_woman + dataA.total_man)) * 100).toFixed(1)}%
                                                                                    </small>
                                                                                </div>
                                                                                <Progress
                                                                                    value={(dataA.total_man / (dataA.total_woman + dataA.total_man)) * 100}
                                                                                    className="progress-blue"
                                                                                    style={{
                                                                                        height: '12px',
                                                                                        borderRadius: '10px',
                                                                                        backgroundColor: '#e3f2fd'
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                        <Col sm={4} className="d-flex align-items-center justify-content-center">
                                                                            {dataBar.datasets && dataBar.datasets[0].data.some(value => value > 0) ? (
                                                                                <div style={{ height: "120px", width: "100%" }}>
                                                                                    <Bar data={dataBar} options={optionsBar} />
                                                                                </div>
                                                                            ) : (
                                                                                <img
                                                                                    src={require("../../../assets/images/microsite/chart-area.svg")}
                                                                                    alt="chart"
                                                                                    style={{ width: "100px", height: "100px" }}
                                                                                />
                                                                            )}
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <DataTable
                                                    className="data-table p-datatable-sm"
                                                    value={patients}
                                                    lazy
                                                    paginator
                                                    rows={10}
                                                    first={(actualPage - 1) * 10}
                                                    loading={loading}
                                                    totalRecords={totalRecords}
                                                    onPage={(e) => goToPage(e.page + 1)}
                                                    responsiveLayout="scroll"
                                                    emptyMessage={
                                                        <div className="text-center py-5">
                                                            <img
                                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                style={{ width: "200px", maxWidth: "32%" }}
                                                                alt="Sin resultados"
                                                            />
                                                            <p className='mt-3 mb-0' style={{ fontSize: "15px", color: "#6c757d" }}>
                                                                No se encontraron resultados.
                                                            </p>
                                                        </div>
                                                    }
                                                >
                                                    <Column
                                                        header="#"
                                                        body={(rowData, options) => {
                                                            const globalIndex = options.rowIndex;
                                                            return globalIndex + 1;
                                                        }}
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />
                                                    {(_id_agreement === "0" && userType === "1") && (
                                                        <Column
                                                            field="code_agreement"
                                                            header="# Convenio"
                                                            headerStyle={headerStyle}
                                                            style={cellStyle}
                                                        />
                                                    )}
                                                    <Column field="nim" header="Nim" headerStyle={headerStyle} style={cellStyle} />
                                                    <Column field="name_patient" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                                    {(userType === "1") && (
                                                        <Column field="curp" header="Curp" headerStyle={headerStyle} style={cellStyle} body={(rowData) => rowData.curp ? rowData.curp : '--'} />
                                                    )}
                                                    {(userType === "1") && (
                                                        <Column field="phone" header="No. Teléfono" headerStyle={headerStyle} style={cellStyle} body={(rowData) => rowData.phone ? rowData.phone : '--'} />
                                                    )}
                                                    <Column field="fechAndDate" header="Fecha" headerStyle={headerStyle} style={cellStyle} />
                                                    {(userType === "2" && _url === sharp) && (
                                                        <Column field="name_type_service" header="Tipo de servicio" headerStyle={headerStyle} style={cellStyle} />
                                                    )}
                                                    <Column
                                                        header="Estatus"
                                                        body={(rowData) => {
                                                            const key = parseInt(rowData?.id_estatus_order, 10);
                                                            const label = statusLabels?.[key] || "SIN ESTATUS";
                                                            const customStyle = {
                                                                borderRadius: '1.5rem',
                                                                fontFamily: 'Montserrat, sans-serif',
                                                                padding: '0.15rem 0.6rem',
                                                                fontSize: '0.7rem',
                                                                lineHeight: '1',
                                                                height: 'auto',
                                                                ...getSeverity(label)
                                                            };
                                                            return <Tag value={label} style={customStyle} />;
                                                        }}
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />
                                                    <Column field="downloads" header="No. Descargas" headerStyle={headerStyle} style={cellStyle} />
                                                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                                </DataTable>
                                            </Col>
                                        </Row>
                                    </Col>
                                    </>
                                     )}
                                    
                                    {activeIndex === 1 && (
                                        <>
                                        <br />
                                           

                                                <Row>

                                                    <Col md="12" sm="12" className=''>
                                                        <Card className='shadow-sm border height-equal pt-1 mb-0 pb-0' >

                                                            <CardBody style={{ padding: '15px' }}>


                                                                <Row className="align-items-start g-2 pt-2">

                                                                    {/* PACIENTE */}
                                                                    <Col md="3" sm="12">
                                                                        <Label style={{ fontSize: "13px", fontWeight: "700" }}>Paciente <span style={{ color: "rgb(0, 103, 199)", fontSize: "14px" }}>*</span></Label>

                                                                        <div style={{
                                                                            border: !isPatientSelected ? "1px solid #f04438" : "1px solid #ffffff",
                                                                            borderRadius: "8px",
                                                                            padding: "2px"
                                                                        }}>
                                                                       <Select
                                                                            options={filteredPatientsOptions}
                                                                            value={selectedPatientOption}
                                                                            onChange={(option) => {
                                                                                setSelectedPatientOption(option);
                                                                                handleSelectChangeHistory(option);
                                                                                setIsPatientSelected(true);
                                                                            }}
                                                                            isLoading={loadingPatients}
                                                                            onInputChange={(inputValue) => {
                                                                            handleSearchPatient(inputValue);
                                                                            return inputValue; 
                                                                        }}
                                                                            placeholder="Escribe al menos 3 letras..."
                                                                            isClearable
                                                                            noOptionsMessage={() => "Escribe mínimo 3 letras"}
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                            }}
                                                                        />
                                                                        </div>

                                                                        {!isPatientSelected && (
                                                                            <div style={{ marginTop: "6px" }}>
                                                                                <span style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: "6px",
                                                                                    fontSize: "12px",
                                                                                    color: "#b42318",
                                                                                    background: "#fef3f2",
                                                                                    padding: "4px 10px",
                                                                                    borderRadius: "999px",
                                                                                    border: "1px solid #fecdca",
                                                                                    fontWeight: 500
                                                                                }}>
                                                                                    <span style={{
                                                                                        width: "6px",
                                                                                        height: "6px",
                                                                                        background: "#f04438",
                                                                                        borderRadius: "50%"
                                                                                    }}></span>

                                                                                    Debes seleccionar un paciente
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </Col>

                                                                    {/* FECHA INICIO */}
                                                                    <Col md="2" sm="6">
                                                                        <Label style={{ fontSize: "13px", fontWeight: "700" }}>Fecha inicio</Label>
                                                                        <Input
                                                                            type="date"
                                                                            name="start_date"
                                                                            value={start_date}
                                                                            onChange={handleInputChangeHistory}
                                                                        className="input-admision mt-2"
                                                                        />
                                                                    </Col>

                                                                    {/* FECHA FIN */}
                                                                    <Col md="2" sm="6">
                                                                        <Label style={{ fontSize: "13px", fontWeight: "700" }}>Fecha fin</Label>
                                                                        <Input
                                                                            type="date"
                                                                            name="end_date"
                                                                            value={end_date}
                                                                            onChange={handleInputChangeHistory}
                                                                        className="input-admision mt-2"
                                                                        />
                                                                    </Col>

                                                                    {studies.length > 0 && (
                                                                        <Col md="3" sm="6">
                                                                            <div className={`study-wrapper ${showStudyHint ? "study-highlight-soft" : ""}`}>

                                                                                <Label style={{ fontSize: "13px", fontWeight: "700" }}>Estudio</Label>


                                                                                <Select
                                                                                    options={options}
                                                                                    value={options.find(opt => opt.value === selectedStudy) || null}
                                                                                    onChange={(option) => setSelectedStudy(option?.value || "")}
                                                                                    placeholder="Seleccionar"
                                                                                    classNamePrefix="react-select"
                                                                                    className="mt-2"
                                                                                    menuPortalTarget={document.body}
                                                                                    styles={{
                                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                        control: (base, state) => ({
                                                                                            ...base,
                                                                                            borderRadius: '8px',
                                                                                            border: showStudyHint
                                                                                                ? '1px solid #0569ff'
                                                                                                : '1px solid #ddd',
                                                                                            padding: '1px',
                                                                                            fontSize: '13px',
                                                                                            boxShadow: state.isFocused ? '0 0 0 1px #0569ff' : 'none',
                                                                                            '&:hover': {
                                                                                                borderColor: '#0569ff'
                                                                                            }
                                                                                        })
                                                                                    }}

                                                                                />


                                                                                {studies[0]?.value === "EMPTY" && (
                                                                                    <div style={{ marginTop: "6px" }}>
                                                                                        <span style={{
                                                                                            display: "inline-flex",
                                                                                            alignItems: "center",
                                                                                            gap: "6px",
                                                                                            fontSize: "12px",
                                                                                            color: "#b42318",
                                                                                            background: "#fef3f2",
                                                                                            padding: "4px 10px",
                                                                                            borderRadius: "999px",
                                                                                            border: "1px solid #fecdca",
                                                                                            fontWeight: 500
                                                                                        }}>
                                                                                            <span style={{
                                                                                                width: "6px",
                                                                                                height: "6px",
                                                                                                background: "#f04438",
                                                                                                borderRadius: "50%"
                                                                                            }}></span>

                                                                                            Sin estudios encontrado para el paciente
                                                                                        </span>
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                        </Col>
                                                                    )}

                                                                    {/* BOTONES */}
                                                                    <Col md="2" sm="12" className='mt-4'>
                                                                        <div style={{
                                                                            display: "flex",
                                                                            gap: "6px",
                                                                            alignItems: "center",
                                                                            height: "100%"
                                                                        }}>

                                                                            <Button
                                                                                onClick={handleLoadTable}
                                                                                disabled={isLoadingTable}
                                                                                color="primary"
                                                                                className='mt-1'
                                                                                style={{
                                                                                    padding: "6px",
                                                                                    borderRadius: "10px",
                                                                                    minWidth: "36px",   
                                                                                    height: "36px",    
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}
                                                                                title='Buscar estudios'
                                                                            >
                                                                                {isLoadingTable
                                                                                    ? <i className="pi pi-spin pi-spinner"></i>
                                                                                    : <i className="pi pi-search"></i>}
                                                                            </Button>

                                                                            <Button
                                                                                onClick={handleDownloadClick}
                                                                                disabled={isDownloadDisabled}
                                                                                color="success"
                                                                                style={{
                                                                                    padding: "6px",
                                                                                    borderRadius: "10px",
                                                                                    minWidth: "36px",   
                                                                                    height: "36px",    
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}
                                                                                className='mt-1'
                                                                                title='Descargar histórico completo'
                                                                            >
                                                                                {isDownloading ? (
                                                                                    <>
                                                                                        <i className="pi pi-spin pi-spinner"></i>&ensp;
                                                                                    </>
                                                                                ) : <i className="fa fa-file-excel-o"></i>}
                                                                            </Button>

                                                                            <Button
                                                                                onClick={() => {
                                                                                    handleClearAll();
                                                                                    setSearchKey(prev => prev + 1);
                                                                                }}
                                                                                color="danger"
                                                                                 style={{
                                                                                    padding: "6px",
                                                                                    borderRadius: "10px",
                                                                                    minWidth: "36px",   
                                                                                    height: "36px",    
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                }}
                                                                                className='mt-1'
                                                                                title='Limpiar filtro'
                                                                            >
                                                                                <i className="fa fa-trash"></i>
                                                                            </Button>

                                                                        </div>
                                                                    </Col>

                                                                </Row>
                                                            </CardBody>
                                                        </Card>


                                                    </Col>



                                                    <Col md="12" sm="12" className='pt-3'>
                                                        <div style={{ width: "100%" }}>

                                                            {/* {isDownloading && (
                                                                <div className="fade-in">
                                                                    <Spinner
                                                                        color="primary"
                                                                        style={{
                                                                            width: "4rem",
                                                                            height: "4rem",
                                                                            animation: "spin 1s linear infinite"
                                                                        }}
                                                                    />
                                                                    <br /><br />
                                                                    <div style={{ fontSize: "22px", fontWeight: "700", color: "#0b72e7" }}>
                                                                        Descargando reporte...
                                                                    </div>
                                                                    <small style={{ color: "#006eff", fontSize: "16px" }}>
                                                                        Esto puede tardar unos segundos
                                                                    </small>
                                                                </div>
                                                            )} */}
                                                            {!(tableData && selectedStudy) && (
                                                                <div style={{
                                                                    width: "100%",
                                                                    height: "70vh",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    flexDirection: "column"
                                                                }}>
                                                                    <img
                                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                        style={{ width: "30%" }}
                                                                        alt="Inicio"
                                                                    />

                                                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                                        Histórico de pacientes
                                                                    </p>
                                                                </div>
                                                            )}

                                                            {tableData && selectedStudy && (
                                                                <>

                                                                    <div className="table-footer-report">
                                                                        {/* <div className="footer-item">
                                                                            <span className="dot"></span>
                                                                            <span>{totalPerfiles} Perfiles</span>
                                                                        </div> */}

                                                                        <div className="footer-item">
                                                                            <span className="icon">
                                                                                <i className="fa fa-list-ul icon-blue"></i>
                                                                            </span>
                                                                            <span>{totalExamenes} Exámenes</span>
                                                                        </div>

                                                                        <div className="footer-item">
                                                                            <span className="icon">
                                                                                <i className="fa fa-flask icon-purple"></i>
                                                                            </span>
                                                                            <span>{totalAnalitos} Analitos</span>
                                                                        </div>

                                                                        <div className="footer-item">
                                                                            <span className="icon">
                                                                                <i className="fa fa-exclamation-triangle icon-yellow"></i>
                                                                            </span>
                                                                            <span>{totalCambios} Cambios</span>
                                                                        </div>

                                                                        <div className="footer-item mr-2">
                                                                            <span className="icon">
                                                                                <i className="fa fa-hashtag" style={{
                                                                                    background: "#e98a0e",
                                                                                    color: "#fff",
                                                                                    padding: "4px",
                                                                                    borderRadius: "6px",
                                                                                    fontSize: "11px"
                                                                                }}></i>
                                                                            </span>
                                                                            <span>{totalNims} NIMs</span>
                                                                        </div>

                                                                        <div className="footer-item">
                                                                            <span className="result-patient-report"></span>
                                                                            <span>Resultado reciente</span>
                                                                        </div>

                                                                        <div className="footer-page">

                                                                        </div>
                                                                    </div>
                                                                    <div className="table-new-container">
                                                                        <table className="table-new">
                                                                            <thead>
                                                                                <tr>
                                                                                    
                                                                                    <th className="col-exam">Examen</th>
                                                                                    <th className="col-analyte">Analito</th>
                                                                                    <th className="col-changes">Cambios</th>
                                                                                        {filteredDynamicColumns.map((col, i) => (
                                                                                            <th
                                                                                                key={i}
                                                                                                className={i === 0 ? "sticky-dynamic-first" : ""}
                                                                                                style={{
                                                                                                ...(i === 0 && {
                                                                                                background: "#16a34a",
                                                                                                color: "#fff",
                                                                                                fontWeight: "700"
                                                                                                }),
                                                                                
                                                                                            }}
                                                                                            >
                                                                                                {col.header}
                                                                                            </th>

                                                                                            

                                                                                        ))}

                                                        
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {filteredRows.length === 0 ? (
                                                                                    <tr>

                                                                                        <div className="text-center p-4">
                                                                                            <img
                                                                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                                                style={{ width: "30%" }}
                                                                                                alt="Sin resultados"
                                                                                            />
                                                                                            <br />
                                                                                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                                                                Sin coincidencias encontradas
                                                                                            </p>
                                                                                        </div>

                                                                                    </tr>
                                                                                ) : (

                                                                                    Object.entries(grouped).map(([exams, items], index) => (
                                                                                        items.map((row, i) => (
                                                                                            <tr
                                                                                                key={`${exams}-${i}`}
                                                                                                className={row.cambios === "SI" ? "row-change" : ""}
                                                                                            >

                                                                                                {i === 0 && (
                                                                                                    <td
                                                                                                        rowSpan={items.length}
                                                                                                        className="col-exam perfil-label-report" style={{ color: "#003674" }}
                                                                                                    >
                                                                                                        {exams}
                                                                                                    </td>
                                                                                                )}

                                                                                                <td className="col-analyte" style={{ fontWeight: "700" }}>{row.analito}</td>

                                                                                                <td className="col-changes">
                                                                                                    <span

                                                                                                        style={{
                                                                                                            color: "#fff",
                                                                                                            backgroundColor: row.cambios === "SI" ? "#ff7300" : "#25acd4",
                                                                                                            padding: "4px 8px",
                                                                                                            borderRadius: "12px",
                                                                                                            fontSize: "12px",
                                                                                                            display: "inline-block",
                                                                                                            fontWeight: "700"

                                                                                                        }}>
                                                                                                        {row.cambios}
                                                                                                    </span>
                                                                                                    

                                                                                                </td>

                                                                                                {filteredDynamicColumns.map((col, j) => (
                                                                                                    <td
                                                                                                        key={j}
                                                                                                        className={j === 0 ? "sticky-dynamic-first cell-recent" : ""}
                                                                                                    >
                                                                                                        {row[col.field] ?? "-"}
                                                                                                    </td>
                                                                                                ))}
                                                                                            </tr>
                                                                                        ))
                                                                                    ))
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </>
                                                            )}



                                                        </div>

                                                    </Col>


                                                </Row>

                                            
                                        </>
                                    )}

                                    



                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div >
            </div >
            <ModalPreview
                {...{
                    modalPreview, togglePreview, handlePreview, typeModall, loadingPdf, previewWorkOrder, workMedicalOrderPDF
                }}
            />
            <Dialog
                header={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="fa fa-exchange" style={{ fontSize: '18px' }}></i>
                        <label className='f-w-600' style={{ fontSize: '18px', margin: 0 }}>Cambio de convenio</label>
                    </div>
                }
                visible={modalchange}
                onHide={toggleAgreement}
                modal
                style={{ width: '90vw', maxWidth: '600px' }}
                headerStyle={{
                    background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '20px 24px',
                    borderRadius: '12px 12px 0 0',
                    border: 'none'
                }}
                pt={{
                    header: { style: { background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)', color: 'white', borderRadius: '12px 12px 0 0' } },
                    headerIcon: { style: { color: 'white' } },
                    content: { style: { padding: "24px" } },
                    root: { style: { borderRadius: '12px', overflow: 'hidden' } }
                }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', padding: '16px 24px', background: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={toggleAgreement}
                            disabled={loadingChange}
                            style={{
                                borderRadius: '8px',
                                padding: '8px 20px',
                                fontWeight: 600,
                                border: 'none',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => !loadingChange && (e.currentTarget.style.transform = 'translateY(-2px)')}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <i className="fa fa-times mr-2"></i>
                            Cancelar
                        </Button>
                        <Button
                            size="sm"
                            disabled={loadingChange}
                            type="button"
                            color="primary"
                            onClick={() => saveAdvancePayment()}
                            style={{
                                borderRadius: '8px',
                                padding: '8px 20px',
                                fontWeight: 600,
                                border: 'none',
                                boxShadow: '0 2px 8px rgba(29, 91, 131, 0.3)',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => !loadingChange && (e.currentTarget.style.transform = 'translateY(-2px)')}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            {loadingChange ? (
                                <>
                                    <i className='pi pi-spin pi-spinner mr-2'></i>
                                    Guardando...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-save mr-2"></i>
                                    Guardar
                                </>
                            )}
                        </Button>
                    </div>
                }
            >

                <Col sm="12" className="pt-2 pb-2">
                    <div
                        className="mb-4"
                        style={{
                            backgroundColor: "#fff8e1",
                            border: "2px solid #ffe082",
                            borderRadius: "12px",
                            padding: "16px 18px",
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            fontSize: "0.9rem",
                            color: "#8a6d3b",
                            boxShadow: '0 2px 8px rgba(240, 173, 78, 0.15)'
                        }}
                    >
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: 'rgba(240, 173, 78, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                        }}>
                            <i className="fa fa-exclamation-triangle" style={{ color: "#f0ad4e", fontSize: '16px' }} />
                        </div>
                        <span style={{ lineHeight: '1.5' }}>
                            El cambio aplicará del <b>convenio origen</b> al <b>nuevo convenio destino</b>.
                        </span>
                    </div>

                    <div className="mb-4">
                        <h6 style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#495057',
                            marginBottom: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <i className="fa fa-user" style={{ color: '#1d5b83' }}></i>
                            Información del Paciente
                        </h6>
                        <Row className="g-3">
                            <Col sm={4}>
                                <div style={{
                                    background: '#f8f9fa',
                                    borderRadius: '10px',
                                    padding: '14px',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <small className="text-muted d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        <i className="fa fa-user mr-1"></i>Paciente
                                    </small>
                                    <span className="fw-semibold f-w-600" style={{ fontSize: "14px", color: '#212529' }}>
                                        {dataInfo.name_patient}
                                    </span>
                                </div>
                            </Col>

                            <Col sm={4}>
                                <div style={{
                                    background: '#f8f9fa',
                                    borderRadius: '10px',
                                    padding: '14px',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <small className="text-muted d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        <i className="fa fa-id-card mr-1"></i>NIM
                                    </small>
                                    <span className="fw-semibold f-w-600" style={{ fontSize: "14px", color: '#212529' }}>
                                        {dataInfo.nim}
                                    </span>
                                </div>
                            </Col>

                            <Col sm={4}>
                                <div style={{
                                    background: '#f8f9fa',
                                    borderRadius: '10px',
                                    padding: '14px',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <small className="text-muted d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        <i className="fa fa-calendar mr-1"></i>Fecha de ingreso
                                    </small>
                                    <span className="fw-semibold f-w-600" style={{ fontSize: "14px", color: '#212529' }}>
                                        {dataInfo.fechAndDate}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Row className='pt-2 g-3'>
                        <Col sm="6">
                            <div
                                style={{
                                    border: "2px solid #1d5b83",
                                    borderRadius: "12px",
                                    padding: "18px",
                                    height: "100%",
                                    background: 'linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%)',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                    <i className="fa fa-arrow-left" style={{ color: '#1d5b83' }}></i>
                                    <small className="text-muted" style={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Convenio origen
                                    </small>
                                </div>
                                <div className="fw-semibold mt-1" style={{ fontSize: "16px", color: '#1d5b83', fontWeight: 700 }}>
                                    {dataInfo.code_agreement}
                                </div>
                            </div>
                        </Col>

                        <Col sm="6">
                            <div
                                style={{
                                    border: "2px dashed #1d5b83",
                                    borderRadius: "12px",
                                    padding: "18px",
                                    height: "100%",
                                    backgroundColor: "#ffffff",
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                    <i className="fa fa-arrow-right" style={{ color: '#1d5b83' }}></i>
                                    <small className="text-muted" style={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Convenio destino
                                    </small>
                                </div>
                                <MultiSelect
                                    value={selectedAgreement}
                                    options={listAgreement}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Seleccione un convenio"
                                    maxSelectedLabels={1}
                                    className="w-100"
                                    display="chip"
                                    filter
                                    filterPlaceholder="Buscar convenio..."
                                    emptyMessage="No hay convenios disponibles"
                                    emptyFilterMessage="No se encontraron resultados"
                                    onChange={(e) => {
                                        const value = e.value;
                                        setSelectedAgreement(value.length > 0 ? [value[value.length - 1]] : []);
                                    }}
                                    style={{ fontSize: '14px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="mt-3">
                                <Label style={{
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#495057',
                                    marginBottom: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <i className="fa fa-comment-o" style={{ color: '#1d5b83' }}></i>
                                    Observaciones
                                </Label>
                                <InputTextarea
                                    value={dataInfo.observation}
                                    onChange={(e) =>
                                        setDataInfo({
                                            ...dataInfo,
                                            observation: e.target.value
                                        })
                                    }
                                    rows={4}
                                    autoResize
                                    className="w-100"
                                    style={{
                                        borderRadius: '10px',
                                        border: '1px solid #e0e0e0',
                                        padding: '12px',
                                        fontSize: '14px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onFocus={(e) => e.currentTarget.style.borderColor = '#1d5b83'}
                                    onBlur={(e) => e.currentTarget.style.borderColor = '#e0e0e0'}
                                    placeholder="Ingrese observaciones sobre el cambio de convenio..."
                                />
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Dialog>

            <Dialog
                header={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="fa fa-history" style={{ fontSize: '18px' }}></i>
                        <label className='f-w-600' style={{ fontSize: '18px', margin: 0 }}>Histórico de cambios</label>
                    </div>
                }
                visible={modalAgreement}
                onHide={toggleHistoric}
                modal
                style={{ width: '90vw', maxWidth: '900px' }}
                headerStyle={{
                    background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '20px 24px',
                    borderRadius: '12px 12px 0 0',
                    border: 'none'
                }}
                pt={{
                    header: { style: { background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)', color: 'white', borderRadius: '12px 12px 0 0' } },
                    headerIcon: { style: { color: 'white' } },
                    content: { style: { padding: "24px" } },
                    root: { style: { borderRadius: '12px', overflow: 'hidden' } }
                }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 24px', background: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={toggleHistoric}
                            style={{
                                borderRadius: '8px',
                                padding: '8px 20px',
                                fontWeight: 600,
                                border: 'none',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <i className="fa fa-times mr-2"></i>
                            Cerrar
                        </Button>
                    </div>
                }
            >
                <Col sm="12" className='pt-2' >
                    <DataTable
                        value={listHistoric}
                        dataKey="id_work_order"
                        expandedRows={expandedRows}
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        className="data-table p-datatable-striped"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                        emptyMessage={
                            <div className="text-center py-5">
                                <i className="fa fa-history" style={{ fontSize: '48px', color: '#ccc', marginBottom: '16px' }}></i>
                                <p className='mt-3 mb-0' style={{ fontSize: "16px", color: "#6c757d", fontWeight: 500 }}>
                                    No hay historial de cambios disponible.
                                </p>
                            </div>
                        }
                    >

                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                                width: "50px",
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            expander={(rowData) => rowData.historic && rowData.historic.length > 0}
                        />
                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                                fontWeight: 500,
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            field="nim"
                            header="NIM"
                            sortable
                        />
                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            field="agreement_origen"
                            header="Convenio Origen"
                            sortable
                        />
                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            field="agreement_destination"
                            header="Convenio Destino"
                            sortable
                        />
                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            field="username"
                            header="Usuario"
                        />
                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            field="observation"
                            header="Observación"
                        />
                        <Column
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                            }}
                            headerStyle={{
                                background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                padding: "12px 8px",
                            }}
                            field="fech"
                            header="Fecha"
                            sortable
                        />

                    </DataTable>
                </Col>
            </Dialog>

            <DialogPreviewResultsMicrosite
                {
                ...{

                            modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview

                }
                }
            />
            
        </Fragment >
    );
}

export default Sampl;